<template>
    <b-container style="margin-top:7rem;">
        <div class="row">
            <div class="col-md-3">
                <b-card
                    style="border-radius:1rem;box-shadow: 0px 3px 6px #00000029;"
                    class="mb-2">
                    <template v-slot:header>
                        <h4 class="pt-3"> <b>Browse Categories</b> </h4>
                    </template>
                    <b-list-group style="cursor:pointer;">
                        <b-list-group-item @click="type=0" href="#" :class="type==0 ? active_class: 'deps'">
                            <div class="d-inline " >
                                <img class="float-left" :src="type==0 ? 'img/posts_page/featured-white.png':'img/posts_page/feature.png'" width="20" height="20" alt="">
                                <span class="float-left" style="text-decoration:none;margin-left:0.45rem;" :class="type==0 ? 'text-white':'text-dark'">Featured</span>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :class="type==1 ? active_class: 'opds'" @click="type=1">

                            <div class="d-inline" >
                                <img class="float-left" :src="type==1 ? 'img/posts_page/new-aals-white.png':'img/posts_page/new-aals.png'"
                                width="20" height="20" alt=""> <span style="text-decoration:none;margin-left:0.45rem;" :class="[type==1 ? 'text-white':'','float-left']" > New Arrivals</span>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :class="type==2 ? active_class: 'opds'" @click="type=2;search_obj.category='Cow'">

                            <div class="d-inline">
                                <img class="float-left" :src="type==2 ? 'img/posts_page/cow-white.png':'img/posts_page/cow_ico_web.png'" width="20" 
                                height="20" alt=""> <span style="text-decoration:none;margin-left:0.45rem;" :class="[type==2 ? 'text-white':'','float-left']">Cow</span> 
                            </div>

                        </b-list-group-item>
                        <b-list-group-item :class="type==3 ? active_class: 'opds'" @click="type=3;search_obj.category='Goat'">
                            <div class="d-inline ">
                                <img class="float-left" :src="type==3 ? 'img/posts_page/goat-white.png':'img/posts_page/goat_io_web.png'" width="20" height="20" alt=""> <span style="text-decoration:none;margin-left:0.45rem;" :class="[type==3 ? 'text-white':'','float-left']">Goats</span> 
                            </div>

                        </b-list-group-item>
                        <b-list-group-item :class="type==4 ? active_class: 'opds'" @click="type=4;search_obj.category='Sheep'">
                            <div class="d-inline ">
                                <img class="float-left" :src="type==4 ? 'img/posts_page/sheep-white.png':'img/posts_page/sheep_ico_web.png'"
                                width="20" height="20" alt=""> <span :class="[type==4 ? 'text-white':'','float-left']" style="text-decoration:none;margin-left:0.45rem;">Sheep</span> 
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :class="type==5 ? active_class: 'opds'" @click="type=5">
                            <div class="d-inline" >
                                <img class="float-left" :src="type==5 ? 'img/posts_page/store-white.png':'img/posts_page/home-black.png'" 
                                width="20" height="20" alt=""> <span class="ml-2" :class="[type==5 ? 'text-white':'','float-left']" style="text-decoration:none;margin-left:0.45rem;">Our Stock</span>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :class="[type==6 ? active_class: 'opds','pr-1 ']" @click="type=6">
                            <div class="d-inline" >
                                <img class="float-left" :src="type==6 ? 'img/posts_page/certified_white.png':'img/posts_page/certified_black.png'" 
                                width="20" height="20" alt=""> 
                                <span  :class="[type==6 ? 'text-white':'','float-left']" style="text-decoration:none;margin-left:0.45rem;">Sadqah Stock</span>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
                <b-card style="border-radius:1rem;box-shadow: 0px 3px 6px #00000029;">
                    <h4>Filter {{search_obj.category}}  </h4>
                    <div>
                        <b-button @click="search_obj.sold_status='s'" :variant="search_obj.sold_status=='s' ? 'success':'white'" :style="search_obj.sold_status=='s' ? 'border:1px solid #dcdcdc;border-bottom-left-radius: 1rem;border-top-left-radius: 1rem;':'border:1px solid #dcdcdc;border-bottom-left-radius: 1rem;border-top-left-radius: 1rem;'">Sold</b-button>
                        <b-button @click="search_obj.sold_status='n'" :variant="search_obj.sold_status=='n' ? 'success':'white'"  :style="search_obj.sold_status=='n' ? 'border:1px solid #dcdcdc;border-bottom-right-radius: 1rem;border-top-right-radius: 1rem;':'border:1px solid #dcdcdc;border-bottom-right-radius: 1rem;border-top-right-radius: 1rem;'">Unsold</b-button>
   
                    </div>
                    <div class="mt-3">
                        <h6 class="text-left">Location</h6>
                        <b-input-group>
                            <template v-slot:prepend>
                                <b-button style="border-left:1px solid #dcdcdc;border-top:1px solid #dcdcdc;border-bottom:1px solid #dcdcdc;" variant="white"><span class="fa fa-map-marker"></span></b-button>
                                
                            </template>
                            <input v-model="search_obj.city" class="form-control" style="border-left:none !important" placeholder="Location"/>

                        </b-input-group>
                    </div>
                    <div class="mt-3">
                        <h6 class="text-left">By Weight</h6> 
                        <b-input-group>
                            <template v-slot:prepend>
                                <b-button style="border-left:1px solid #dcdcdc;border-top:1px solid #dcdcdc;border-bottom:1px solid #dcdcdc;" variant="white"><span class="fa fa-shopping-bag"></span></b-button>
                                
                            </template>
                            <select class="form-control" v-model="search_obj.weight" name="" id="">
                                <option value="0-40">0-40 kg</option>
                                <option value="40-80">40-80 kg</option>
                                <option value="80-120">80-120 kg</option>
                                <option value="120-160">120-160 kg</option>
                                <option value="160-200">160-200 kg</option>

                            </select>

                        </b-input-group>
                          
                    </div>
                    <div class="mt-3">
                        <h6 class="text-left">By Price</h6>
                        <!-- <div class="d-flex d-md-flex"> -->
                        <b-input-group>
                            <template v-slot:prepend>
                                <b-button style="border-left:1px solid #dcdcdc;border-top:1px solid #dcdcdc;border-bottom:1px solid #dcdcdc;" variant="white"><span class="fa fa-dollar"></span></b-button>
                                
                            </template>
                            <input class="form-control" v-model="search_obj.min_price" min="2000"  type="number" style="border-left:none !important" placeholder="enter min price"/>

                        </b-input-group>
                        <b-input-group class="mt-2">
                        <template v-slot:prepend>
                                <b-button  style="border-left:1px solid #dcdcdc;border-top:1px solid #dcdcdc;border-bottom:1px solid #dcdcdc;" variant="white"><span class="fa fa-dollar"></span></b-button>
                                
                            </template>
                            <input v-model="search_obj.max_price" max="100000" min="2000" class="form-control"  type="number" style=";border-left:none !important" placeholder="enter max Price"/>

                        </b-input-group>
                          <!-- <span style="align-self: center;">Min</span>  <b-input type="number" class="ml-1 font-control col-md-4 mr-2"/>
                           <span style="align-self: center;">Max</span>  <b-input type="number" class="ml-1 font-control col-md-4"/> -->
                        <!-- </div> -->

                            <!-- <a-slider id="test"  range :defaultValue="[2000 ,100000]"  /> -->

                    </div>
                    <div class="mt-3">
                        <b-button variant="success" class="pr-5 pl-5" @click="searchPost()">Apply</b-button>
                    </div>
                </b-card>
                
            </div>
            <div class="col-md-9">
                <FeaturedPosts v-if="type==0" @chat-show="hideDialog"/>
                <RecentPosts v-if="type==1" @chat-show="hideDialog"/>
                <CowPosts v-if="type==2" @chat-show="hideDialog"/>
                <SheepPosts v-if="type==4" @chat-show="hideDialog"/>
                <GoatPosts v-if="type==3" @chat-show="hideDialog" />
                <OurStock v-if="type==5" @chat-show="hideDialog"/>
                <CSadqahStock v-if="type==6" @order-item="orderItem"/>
                <CSadqahOrder :AllPostFlag="true" :order="order" class="mt-5" v-if="type==7"  />
                <SearchResultPosts :search_results="search_results" v-if="type==8" />
            </div>
            <b-modal id="first-chat"  title="Send Message" @ok="lc_sendMessage()" ok-title="Send" >
                <b-form-group
                    id="fieldset-1"
                    label="Write your message">
                        <b-form-textarea
                        id="textarea"
                        v-model="new_chat_obj.message"
                        placeholder="Type here..."
                        rows="3"
                        max-rows="6"
                        ></b-form-textarea>
                </b-form-group>
            </b-modal>
        </div>
    </b-container>
</template>
<script>
import FeaturedPosts from "../components/FeaturedPosts.vue";
import CowPosts from "../components/CowPosts.vue";
import SheepPosts from "../components/SheepPosts.vue";
import GoatPosts from "../components/GoatPosts.vue";
import RecentPosts from "../components/RecentPosts.vue";
import CSadqahStock from "../components/CSadqahStock.vue";
import CSadqahOrder from "../components/CSadqahOrder.vue";
import SearchResultPosts from "../components/SearchResultPosts.vue";


import OurStock from "../components/OurStock.vue";
import {mapGetters} from 'vuex'
import {RepositoryFactory} from '../Repository/RepositoryFactory'
const UserRepository=RepositoryFactory.get('user_repository')
import globalfuns from '../mixins/globalfuns'
import unixTime  from 'unix-time'
import PostsRepository from '../Repository/PostsRepository';

export default {
    name:'AllPosts',
    props:['types'],
    mixins:[globalfuns],
    components:{
        FeaturedPosts,
        CowPosts,
        SheepPosts,
        GoatPosts,
        RecentPosts,
        OurStock,
        CSadqahStock,
        CSadqahOrder,
        SearchResultPosts
    },
    data() {
        return{
        search_results:[],    
        search_obj:{
        filter: "yes",
        category: "Cow",
        min_price:'',
        max_price:'',
        price: "2000-100000",
        weight:"no",
        city:"",
        sold_status:"n"
        },    
        order:'',

        selected_post:'',
        type:0,
        msg_notif_obj:{
        sender_id:'',
        post_owner_id: '',
        post_image:'',
        channel:''
        },
      
    }
        
    },
    computed:{
        ...mapGetters(['loggedUser','chatUser']),
        active_class(){
            return 'active'
        }
    },
    mounted(){
        localStorage.setItem("route","AllPosts")
    },
    created(){
        window.scrollTo(0,0)
        localStorage.setItem("route","AllPosts")
        if(this.types!=null) {
            this.type=this.types
        }
      
    },
    methods:{
    async searchPost() {
        if(this.search_obj.max_price>=2000 && this.search_obj.min_price>=2000 && this.search_obj.max_price<=100000){
                this.search_obj.price=this.search_obj.min_price+'-'+this.search_obj.max_price
                console.log(this.search_obj)
                let objs={...this.search_obj}
                if(objs.city==''){
                    objs.city='no'
                }
                delete objs.min_price
                delete objs.max_price
                let {data} = await PostsRepository.search_post(objs)
                console.log(data)
                if(data.length>0){
                    this.search_results=data
                    this.type=8
                }
                else{
                  this.$store.commit('setNotifications',{message:'No search results on this criteria',type:'error'})

                }
                

        }
        else{
            this.$store.commit('setNotifications',{message:'Min Price is 2000 and Maxium price is 100000',type:'error'})

        }


    },
    orderItem(item) {
          this.type=7
          this.order=item
    },
    hideDialog(item){
        console.log(item)
        this.$bvModal.hide('modal-lg')
        this.$bvModal.show('first-chat')
        this.selected_post=item


    },
        async lc_sendMessage(){
      if(this.loggedUser!=null){
         let isNew=true
        
        // let senderphone = this.FB !=null ? this.loggedUser.id : this.loggedUser.phoneno
        let sendername=this.loggedUser.nickname
        this.new_chat_obj.post_id=this.selected_post.id
        this.new_chat_obj.sender=this.loggedUser.id
        this.new_chat_obj.timestamp=unixTime(new Date())
        this.new_chat_obj.image_key=this.selected_post.imagekey

        this.new_user_obj = {
            last_date:this.getTodaysDate(),
            last_time:this.getCurrentTime()
        }
        

        let {data}=await UserRepository.getuser({user_id:this.selected_post.user_id})
        let receivername=data[0].nickname
        let checks
        if(this.chatUser.chat_groups!=null){
            checks=Object.keys(this.chatUser.chat_groups).find(item=>this.chatUser.chat_groups[item].receiver_id==data[0].id)
        }
        let chatgroup_id
        if(checks!=null){
        chatgroup_id=this.chatUser.chat_groups[checks].id
        }
        isNew=checks!=null ? false:true

        let contacts={
            sender_name:sendername,
            receiver_name:receivername,
            sender_id:this.loggedUser.id,
            receiver_id:data[0].id
        }


        this.msg_notif_obj.sender_id=this.loggedUser.id
        this.msg_notif_obj.post_owner_id=this.selected_post.user_id
        this.msg_notif_obj.channel=this.loggedUser.id+'_'+data[0].id
        this.msg_notif_obj.post_image=this.selected_post.imagekey

        let resps = await UserRepository.sendmsgnotification(this.msg_notif_obj)
       
        // console.log(chatgroup_id)
        // console.log(isNew)
        // console.log(contacts)
        // console.log(this.new_user_obj)
        // console.log(this.new_chat_obj)
        
        
        this.$store.dispatch("initialMessage",{chatgroup_id:chatgroup_id,isNew:isNew,contacts:contacts,new_user_obj:this.new_user_obj,new_chat_obj:this.new_chat_obj})
        this.$bvModal.hide('first-chat')
        this.$router.push({name:'Dashboard',params: { active_prop: 9 }})

      }
      else{
        this.$store.commit('setNotifications',{message:'Login before messaging',type:'error'})

      }

    },
    }
  }
</script>

<style scoped>
button:focus{
        outline: none !important;
        box-shadow: none  !important;
        border-left:1px solid #dcdcdc !important;
        border-top:1px solid #dcdcdc !important;
        border-bottom:1px solid #dcdcdc !important;

}
select{
    border-left:none !important;
}
input:focus{
        outline: none !important;
        box-shadow: none  !important;
        border:1px solid #dcdcdc !important
}
.form-control:focus{
    /* border-color: green !important; */
    outline: none !important;
    border:1px solid #dcdcdc !important;
    box-shadow: none  !important;




}
.list-group-item:first-child {
    /* border-top-left-radius: 0.25rem; */
    border-top: none;
    border-left:none !important;
    border-right:none !important;
}
.list-group-item:first-child:hover {
    /* border-top-left-radius: 0.25rem; */
    text-decoration: none !important;
    border-top: none;
    border-left:none !important;
    border-right:none !important;
        border-bottom:none !important;

}
.active{
    background-color: #28a745 !important;
    color:black !important;
    /* border-top:1px solid #0A0101 !important; */
    border-left:none;
    border-right:none;
    /* border-bottom: none !important */

}

.opds{
    /* border-top:1px solid #0A0101 !important; */
    border-left:none;
    border-right:none;
    /* border-bottom: none !important */

}
.card-header{
    background-color:white !important
}
</style>